import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { getImageUrl } from "../../../Utils/index";
import "../../../Assets/Scss/StoreHead.scss";
import PlaceHolderImage from "../../../Assets/Images/PlaceholderImage.png";
import { useState } from "react";
import Breadcrumbs from "../../../Components/Breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { FaStar } from "react-icons/fa";
import { Rating } from "react-simple-star-rating";
import { Badge, Modal } from "react-bootstrap";
import "../../../Assets/Scss/Store.scss";
import MonthYearMacros from "../../Ui/MonthYearMacros";

function Head({ store, descriptionRef }) {
  let [readmore, setReadMore] = useState(false);

  const togleReadmore = () => {
    setReadMore((readmore) => !readmore);
  };
  const { domainData } = useSelector((state) => state.Website);

  const [show, setShow] = useState(false);
  const [rating, setRating] = useState(0);
  const [randomN, setRandomN] = useState(876);

  const handleRating = (rate) => {
    setRating(rate);
    setRandomN((r) => r + 1);
  };
  const onPointerEnter = () => console.log("Enter");
  const onPointerLeave = () => console.log("Leave");
  const onPointerMove = (value, index) => console.log(value, index);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Breadcrumbs path={[{ path: "category", name: "Categories" }]} />
      <div className="head">
        <Container style={{ background: "#FFF", position: "relative" }}>
          <Row className="py-3">
            <Col sm={12} md={4} lg={3} style={{ display: "flex" }}>
              <img
                src={getImageUrl(store?.image, PlaceHolderImage)}
                className="image"
                style={{
                  height: "100px",
                }}
                alt={store?.title || ""}
              />
            </Col>
            <Col sm={12} md={8} lg={6} className="mt-2">
              <h2>{store?.name}</h2>
              {store?.totalRecords && (
                <Badge
                  bg="inf"
                  style={{
                    fontSize: ".8rem",
                    marginRight: "4px",
                    backgroundColor: domainData
                      ? domainData.header_color
                      : "#fff",
                    color: "white",
                  }}
                >
                  {store?.totalRecords ? "Total coupons :" : ""}{" "}
                  {store?.totalRecords}
                </Badge>
              )}
              <br></br>
              {/* {store.summary && (
                <MonthYearMacros input={store.summary.slice(0, 15)} />
              )} */}
      
              <span
                onClick={() => {descriptionRef.current?.scrollIntoView({ behavior: 'smooth' })}}
                style={{ color: domainData?.header_color, cursor: "pointer" }}
              >
                &nbsp;Read more
              </span>
            </Col>
          </Row>
          {!readmore && (
            <div id="rating-div">
              <FaStar
                style={{
                  color: "gold",
                  fontSize: "3rem",
                  paddingBottom: "10%",
                }}
              />
              <p
                style={{ display: "inline", color: "black", fontWeight: "350" }}
              >
                &nbsp;
                <span style={{ fontSize: "2rem", fontWeight: "350" }}>4</span>
                <span style={{ fontSize: "1.2rem" }}> /5</span>
                <p style={{ fontSize: ".7rem", textAlign: "right" }}>
                  {" "}
                  <strong
                    style={{
                      fontSize: ".6rem",
                      borderRadius: "10px",
                      border: `2px solid ${
                        domainData?.header_color
                          ? domainData?.header_color
                          : "fff"
                      }`,
                      padding: "0 2px",
                      marginRight: "3px",
                    }}
                  >
                    {randomN} votes
                  </strong>
                  <Badge
                    onClick={handleShow}
                    bg="inf"
                    data-backdrop="false"
                    style={{
                      fontSize: ".7rem",
                      borderRadius: "10px",
                      padding: "3px",
                      backgroundColor: domainData?.header_color
                        ? domainData?.header_color
                        : "fff",
                      color: "white",
                      float: "right",
                      marginLeft: "2px",
                      cursor: "pointer",
                    }}
                  >
                    {rating > 0 ? `Rated ${rating}/5` : "Rate this"}
                  </Badge>
                </p>
              </p>
              <Modal show={show} backdrop={true} onHide={handleClose}>
                <Modal.Header closeButton style={{ fontSize: "1rem" }}>
                  <Modal.Title style={{ textAlign: "center", width: "100%" }}>
                    Rate {store?.name}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body
                  style={{ padding: "3% 10% 3% 32%", fontSize: "3rem" }}
                >
                  <Rating
                    onClick={handleRating}
                    onPointerEnter={onPointerEnter}
                    onPointerLeave={onPointerLeave}
                    onPointerMove={onPointerMove}
                  />
                </Modal.Body>
                <Modal.Footer style={{ color: "black" }}>
                  <div style={{ textAlign: "center", width: "100%" }}>
                    {rating > 0
                      ? "Thanks for Rating."
                      : `Rated 4/5, out of ${randomN} votes.`}
                  </div>
                </Modal.Footer>
              </Modal>
            </div>
          )}
        </Container>
      </div>
    </>
  );
}

export default Head;
